// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__rZvd5","icon":"styles_icon__273b6"};